import { render, staticRenderFns } from "./PacketList.vue?vue&type=template&id=a0454cd6"
import script from "./PacketList.vue?vue&type=script&lang=js"
export * from "./PacketList.vue?vue&type=script&lang=js"
import style0 from "./PacketList.vue?vue&type=style&index=0&id=a0454cd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports